<template>
  <section id="main">
    <div class="grid">
      <div class="col-1-1">
        <section
          id="orderTicketsContainer"
          class="ptb-xxlg"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const route = useRoute()
  const id = Array.isArray(route.query.id) ? route.query.id[0] : route.query.id
  const event = Array.isArray(route.query.programma) ? route.query.programma[0] : route.query.programma

  const { data: eventData } = await useBaseAsyncData<{ title?: string }>(`/events/${event ?? ''}`)

  const { public: publicConfig } = useRuntimeConfig()
  const loadedTicketsContainer = useState<boolean>(`loaded-ticket-container-${id}`, () => false)

  useHead({
    title: eventData.value ? `Koop kaarten voor ${eventData.value.title}` : 'Koop kaarten',
    meta: [
      {
        name: 'description',
        content: eventData.value ? `Koop hier je kaarten voor ${eventData.value.title}.` : 'Koop hier je kaarten.',
      },
    ],
  })

  if (loadedTicketsContainer.value) {
    // force refresh otherwise iframe problems
    loadedTicketsContainer.value = false
    window.location.reload()
  }

  onMounted(async () => {
    ;(window as { tww?: (...args: unknown[]) => void }).tww?.(
      'Activity',
      id,
      'orderTicketsContainer',
      'ordercart',
      `${publicConfig.siteUrl}/winkelmand`,
    )
    loadedTicketsContainer.value = true
  })
</script>
